<template>
  <component v-on="$listeners" :is="tag" class="app-heading" data-jest="app-heading">
    <slot />
    {{ text }}
    <slot name="after-text" />
  </component>
</template>

<script>
export default {
  name: 'AppHeading',
  props: {
    tag: {
      type: String,
      default: 'h1',
    },
    text: {
      type: String,
      default: '',
    },
  },
}
</script>

<style scoped>
.app-heading {
  color: var(--c-primary);
}
</style>
